import { render, staticRenderFns } from "./GameHeader.vue?vue&type=template&id=3bd39b9d&scoped=true"
import script from "./GameHeader.vue?vue&type=script&lang=js"
export * from "./GameHeader.vue?vue&type=script&lang=js"
import style0 from "./GameHeader.vue?vue&type=style&index=0&id=3bd39b9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.100.1__lodash@4.17.21_webpack@5.100.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd39b9d",
  null
  
)

export default component.exports